"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EmptyMessages = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _colors = _interopRequireDefault(require("../../colors"));

var EmptyMessages = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(EmptyMessages, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(EmptyMessages);

  function EmptyMessages() {
    (0, _classCallCheck2["default"])(this, EmptyMessages);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(EmptyMessages, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({}, this.props, {
        style: {
          height: 94,
          width: 94
        },
        viewBox: "0 0 94 94"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: _colors["default"].lychee[700],
        d: "M60.6666667,9.33333333 L60.6666667,42 L14.7933333,42 L9.33333333,47.46 L9.33333333,9.33333333 L60.6666667,9.33333333 L60.6666667,9.33333333 Z M65.3333333,0 L4.66666667,0 C2.1,0 0,2.1 0,4.66666667 L0,70 L18.6666667,51.3333333 L65.3333333,51.3333333 C67.9,51.3333333 70,49.2333333 70,46.6666667 L70,4.66666667 C70,2.1 67.9,0 65.3333333,0 Z M88.6666667,18.6666667 L79.3333333,18.6666667 L79.3333333,60.6666667 L18.6666667,60.6666667 L18.6666667,70 C18.6666667,72.5666667 20.7666667,74.6666667 23.3333333,74.6666667 L74.6666667,74.6666667 L93.3333333,93.3333333 L93.3333333,23.3333333 C93.3333333,20.7666667 91.2333333,18.6666667 88.6666667,18.6666667 Z"
      }));
    }
  }]);
  return EmptyMessages;
}(_react["default"].PureComponent);

exports.EmptyMessages = EmptyMessages;
var _default = EmptyMessages;
exports["default"] = _default;